import * as yup from "yup"
import { Form, Formik } from "formik"
import { useAppLocalization } from "../../../../../../modules/localization/components/AppLocalizationProvider"
import { toCurrency, toDineroLossy, toMonetaryAmount } from "../../../../../../modules/currency/currencyLib"
import { selectEffectiveUserType } from "../../../../../../modules/context/contextSelectors"
import { useAppSelector } from "../../../../../../modules/store/storeHooks"
import { UserType } from "../../../../../../modules/login/loginTypes"
import { ProductWishFormContent } from "./ProductWishFormContent"
import { ProductWishItem } from "./ProductWishDialog"

export type ProductWishFormValues = Readonly<{
    name: string
    quantity?: string
    price?: number
}>

type ProductWishFormProps = Readonly<{
    onSubmit: (val: ProductWishItem) => void
}>

export function ProductWishForm({ onSubmit }: ProductWishFormProps) {
    const effectiveUserType = useAppSelector(selectEffectiveUserType)
    const isShowPriceField = effectiveUserType !== UserType.USER
    const { l10n } = useAppLocalization()

    const defaultInitialValues = {
        name: "",
    }

    const validationSchema = yup.object({
        name: yup.string().required(l10n.getString("required-field")),
        quantity: yup.string().required(l10n.getString("required-field")),
        price: yup.number().when([], {
            is: () => isShowPriceField,
            then: (schema) => schema.required(l10n.getString("required-field")),
            otherwise: (schema) => schema.notRequired().nullable(),
        }),
    })

    function handleSubmit(values: ProductWishFormValues) {
        const modifyData = {
            ...values,
            quantity: Number(values.quantity),
            price: values.price ? toMonetaryAmount(toDineroLossy(values.price, toCurrency("DKK"))) : undefined,
        }
        onSubmit(modifyData)
    }

    return (
        <Formik<ProductWishFormValues>
            enableReinitialize
            initialValues={defaultInitialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            validateOnBlur={false}
        >
            <Form>
                <ProductWishFormContent isShowPriceField={isShowPriceField} />
            </Form>
        </Formik>
    )
}
